import React from 'react'
import { useHasRequiredPermissions } from '../../../hook/useHasRequiredRoles'

export type Permission =
  | 'users_read'
  | 'users_edit'
  | 'users_create'
  | 'users_delete'
  | 'roles_read'
  | 'roles_edit'
  | 'roles_create'
  | 'roles_delete'
  | 'programs_create'
  | 'programs_read'
  | 'programs_edit'
  | 'applicants_create'
  | 'applicants_edit'
  | 'applicants_delete'
  | 'appeals_edit'
  | 'appeals_read'
  | 'task_list_view_read'
  | 'task_list_view_edit'
  | 'scholarship_management_read'
  | 'scholarship_management_edit'
  | 'provider_management_read'
  | 'provider_management_edit'
  | 'ledger_control_read'
  | 'dashboard_read'
  | 'dashboard_create'
  | 'dashboard_edit'
  | 'dashboard_delete'
  | 'applicants_read'
  | 'task_next_up_queue_read'
  | 'task_next_up_queue_edit'
  | 'task_next_up_queue_create'
  | 'home_create'
  | 'home_read'
  | 'appeals_create'
  | 'task_list_view_create'
  | 'scholarship_management_create'
  | 'provider_management_create'
  | 'provider_management_delete'
  | 'ledger_control_create'
  | 'provider_users_read_only_create'
  | 'provider_users_read_only_read'
  | 'provider_users_read_only_edit'
  | 'provider_users_read_only_delete'
  | 'provider_users_owner_admin_finance_create'
  | 'provider_users_owner_admin_finance_read'
  | 'provider_users_owner_admin_finance_edit'
  | 'provider_users_owner_admin_finance_delete'
  | 'provider_user_roles_management_create'
  | 'academic_term_management_create'
  | 'academic_term_management_read'
  | 'academic_term_management_edit'
  | 'academic_term_management_delete'

type Props = {
  requiredPermissions: Permission[]
  children: React.ReactNode
  fallbackComponent?: React.ReactNode
}

export default function AdminAuthGuard(props: Props) {
  const { requiredPermissions, children, fallbackComponent } = props
  const hasRequiredPermissions = useHasRequiredPermissions(requiredPermissions)

  if (!hasRequiredPermissions) {
    return fallbackComponent ?? null
  }

  return <>{children}</>
}
